import React from "react";
import { Divider } from "@material-ui/core";

export default function OutlinerDivider(props) {
  const { major } = props;
  const majorClass = major ? "major" : "";
  return <Divider className={`outliner-divider ${majorClass}`} />;
}
